window.VGSearch = {
	body: $('body'),
	container: $('.search'),
	tm: null,
	currentRequest: null,
	lastRequestData: null,

	open: function ($self, options) {
		this.body.addClass('search-open');

		if ('focus' in options && options.focus) {
			setTimeout(() => {
				VGSearch.container.find('input').focus();
			}, 100);
		}

		VGSearch.request($self, options);
	},

	close: function ($self) {
		this.body.removeClass('search-open');
		$self.blur();
	},

	request: function ($self, options) {
		let val = $self.val();
		options = options || {};

		let params = {search: val};

		if (this.currentRequest) {
			this.currentRequest.abort();
		}

		let searchRequest = function () {
			if (params?.search === this.lastRequestData?.search) {
				return;
			}

			this.lastRequestData = params;

			VGSearch.setLoading(true);
			VGSearch.currentRequest = $.get('/search/lookup', params, function (data) {
				VGSearch.setView(data);
				VGSearch.currentRequest = null;

				VGSearch.setLoading(false);
			})
		};

		if (typeof options.timeout === 'undefined' || options.timeout === true) {
			clearTimeout(this.tm);
			this.tm = setTimeout(searchRequest, 500);
		} else {
			searchRequest();
		}
	},

	setView: function (data) {
		VGSearch.container.find('.search-result--content').html(data.view);

		let $carousels = document.querySelectorAll('.swiper');
		if ($carousels.length) {
			for (let carousel of $carousels) {
				VGCarousel.init(carousel);
			}
		}
	},

	setLoading: function (loading = true) {
		VGSearch.container.find('.search-result').toggleClass('loading', loading);
	},
};

$(document).ready(function () {
	VGSearch.container.find('input').on('focus', function () {
		VGSearch.open($(this), {
			timeout: false,
		});

		return false;
	});

	VGSearch.container.find('input').on('search', function () {
		VGSearch.request($(this), {
			timeout: false,
		});

		return false;
	});

	$(document).find('[data-vg-toggle="search-mobile"]').on('click', function (e) {
		VGSearch.open($(this), {
			timeout: false,
			focus: true
		});

		return false;
	});

	$(document).find('[data-vg-dismiss="search"]').on('click', function (e) {
		VGSearch.close($(this));

		return false;
	});

	VGSearch.container.on('click', '[data-keysearch]', function () {
		VGSearch.container.find('input')
			.val($(this).data('keysearch'))
			.trigger('search');

		return false;
	});

	VGSearch.container.find('input').on('keyup', function () {
		VGSearch.request($(this));

		return false;
	});

	$(document).keyup(function (e) {
		if (e.key === "Escape" && VGSearch.body.hasClass('search-open')) {
			VGSearch.close($('.search').find('input'));
		}
	});
});
